import React, { useContext } from "react"
import { Platform, ScrollView, StyleSheet, Text, View } from "react-native"
import { ShadowView, textStyles } from "../style"
import { ThemeContext } from "../utility/context/ThemeContext"
import { FontAwesome6, Ionicons } from "@expo/vector-icons"
import { PermissionType } from "@ecountabl/lib"
import PermissionToggle from "../utility/permission-toggle"
import ThemeSelector from "../utility/theme-selector"

const Permissions = () => {
  const { theme } = useContext(ThemeContext)
  const { textMain } = theme.colors

  return (
    <ScrollView style={{flex: 1}} contentContainerStyle={{gap: 16}}>
      <View style={{gap: 8}}>
        <Text style={[textStyles.body, {color: textMain}]}>
          Your impact. Your rules. You can customize your Impact Banking experience to your liking.
        </Text>
        <Text style={[textStyles.body, {color: textMain}]}>
          Don&apos;t worry about being locked into your choice here.{' '}
          You can always change your preferences later in the settings.
        </Text>
      </View>
      
      <View style={{gap: 8}}>
        <Text style={[textStyles.h2, {color: textMain}]}>Theme</Text>
        <Text style={[textStyles.body, {color: textMain}]}>
          Choose which theme you want to use for Impact Banking.
        </Text>
        <ThemeSelector />
      </View>
      {Platform.OS !== 'web' ? (
        <View style={{gap: 8}}>
          <Text style={[textStyles.h2, {color: textMain}]}>Permission</Text>
          <Text style={[textStyles.body, {color: textMain}]}>
            Notifications can be helpful for events needing your attention.
          </Text>
          <ToggleSection
            icon={<Ionicons name="notifications" size={20} color={textMain} />}
            title="Notifications"
            permission="notifications"
          />
        </View>
      ) : null}
    </ScrollView>
  )

  // below not in use until we bring back location permissions
  return (
    <ScrollView style={{flex: 1}} contentContainerStyle={{gap: 16}}>
      <View style={{gap: 8}}>
        <Text style={[textStyles.body, {color: textMain}]}>
          Your impact. Your rules. We believe in giving you control over your data and allowing your Impact Banking{' '}
          experience to be as personalized as you want it to be.
        </Text>
        <Text style={[textStyles.body, {color: textMain}]}>
          Don&apos;t worry about being locked into your choice here.{' '}
          You can always change your preferences later in the settings.
        </Text>
      </View>
      
      <View style={{gap: 8}}>
        <Text style={[textStyles.h2, {color: textMain}]}>Permissions</Text>
        <Text style={[textStyles.body, {color: textMain}]}>
          Choose which permissions you want to grant Impact Banking to use.
        </Text>
        <ToggleSection
          icon={<FontAwesome6 name="location-dot" size={20} color={textMain} />}
          title="Location Access"
          permission="location"
        />
        {
          Platform.OS !== "web" ? (
            <ToggleSection
              icon={<Ionicons name="notifications" size={20} color={textMain} />}
              title="Notifications"
              permission="notifications"
            />
          ) : null
        }
      </View>
      
      <View style={{gap: 8}}>
        <Text style={[textStyles.h2, {color: textMain}]}>Theme</Text>
        <Text style={[textStyles.body, {color: textMain}]}>
          Choose which theme you want to use for Impact Banking.
        </Text>
        <ThemeSelector />
      </View>
    </ScrollView>
  )
}

type ToggleSectionProps = {
  icon: React.ReactNode
  title: string
  permission: PermissionType
}

const ToggleSection = ({icon, title, permission}:ToggleSectionProps) => {
  const { theme } = useContext(ThemeContext)
  const { textMain, bgSecond, borderColor } = theme.colors

  return (
    <ShadowView style={[styles.toggleRow, {backgroundColor: bgSecond, borderColor: borderColor}]}>
      <View style={{flexDirection: 'row', alignItems: 'center', gap: 10}}>
        {icon}
        <Text style={[textStyles.body, {color: textMain}]}>{title}</Text>
      </View>
      <PermissionToggle
        permission={permission}
      />
    </ShadowView>
  )
}

const styles = StyleSheet.create({
  toggleRow: {
    width: "100%",
    paddingVertical: 10,
    paddingHorizontal: 16,
    borderRadius: 10,
    borderWidth: 1,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center"
  }
})

export default Permissions